var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20.621 8.45C19.571 3.83 15.541 1.75 12.001 1.75H11.991C8.46095 1.75 4.42095 3.82 3.37095 8.44C2.20095 13.6 5.36095 17.97 8.22095 20.72C9.23467 21.7012 10.5901 22.2498 12.001 22.25C13.361 22.25 14.721 21.74 15.771 20.72C18.631 17.97 21.791 13.61 20.621 8.45Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 13.4602C12.4151 13.4602 12.8247 13.3787 13.2069 13.2204C13.5891 13.0621 13.9363 12.83 14.2288 12.5375C14.5213 12.245 14.7534 11.8978 14.9117 11.5156C15.07 11.1334 15.1514 10.7238 15.1514 10.3102C15.1514 9.89649 15.07 9.48688 14.9117 9.1047C14.7534 8.72253 14.5213 8.37527 14.2288 8.08277C13.9363 7.79027 13.5891 7.55824 13.2069 7.39994C12.8247 7.24163 12.4151 7.16016 12.0014 7.16016C11.166 7.16016 10.3648 7.49203 9.77405 8.08277C9.18331 8.67351 8.85144 9.47472 8.85144 10.3102C8.85144 11.1456 9.18331 11.9468 9.77405 12.5375C10.3648 13.1283 11.166 13.4602 12.0014 13.4602Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9f93225d.svg";
export { ForwardRef as ReactComponent };